module.exports = __webpack_public_path__ + "static/ester-b90ce6b5e64d4d46c761b76ef1e753a7.jpg";